<template>
	<div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "signout",
	methods: {
		...mapActions("Auth", ["signout"]),
	},
	created: async function() {
        await this.signout();
	},
};
</script>
